import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { fuelPlans } from "@/lib/navcalc";
import { Fuel } from "lucide-react";
import { FuelParamsTable, FuelBilan } from "./FuelTables";

export default function FuelTab({ briefing, setBriefing, aircraft, nav }) {
  const burn = Number(aircraft?.fuelBurn) || 0;
  const fuel = briefing.fuel || {};
  const plans = fuelPlans(briefing, nav, aircraft);
  const setFuel = (k, v) => setBriefing((b) => ({ ...b, fuel: { ...b.fuel, [k]: v } }));

  return (
    <div className="grid grid-cols-1 gap-5 xl:grid-cols-5">
      <div className="glass rounded-2xl p-6 xl:col-span-3">
        <h3 className="mb-4 flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-wide text-cyan-400">
          <Fuel className="h-4 w-4" /> Paramètres carburant
        </h3>
        <FuelParamsTable plan={plans[0].plan} setFuel={setFuel} />
        <p className="mt-2 text-[11px] text-slate-500">Saisissez un temps ou des litres : la conversion se fait automatiquement (conso {burn} L/h).</p>

        <div className="mt-5 flex flex-wrap items-end gap-4">
          {plans.map((p) => (
            <div key={p.onboardKey} className="w-44">
              <Label className="text-[11px] uppercase tracking-wider text-slate-400">Embarqué{p.title && plans.length > 1 ? ` ${p.title.toLowerCase()}` : ""} (L)</Label>
              <Input type="number" value={fuel[p.onboardKey] ?? 0} onChange={(e) => setFuel(p.onboardKey, e.target.value === "" ? "" : Number(e.target.value))}
                data-testid={p.onboardKey === "onboardL" ? "fuel-onboard-input" : "fuel-onboard-ret-input"}
                className="mt-1 border-cyan-500/40 bg-slate-900/60 font-mono-data text-cyan-200" />
            </div>
          ))}
          {nav.ret && (
            <label className="flex cursor-pointer items-center gap-2 rounded-lg border border-slate-700 bg-slate-900/40 px-3 py-2">
              <Switch checked={!!fuel.splitRoundTrip} onCheckedChange={(v) => setFuel("splitRoundTrip", v)} data-testid="fuel-split-toggle" />
              <span className="text-sm text-slate-200">Bilans séparés aller / retour (ravitaillement)</span>
            </label>
          )}
        </div>
        <p className="mt-4 text-xs text-slate-500">
          Capacité réservoirs : {aircraft?.fuelCapacity || 0} L · Conso {burn} L/h · Non utilisable {aircraft?.unusableFuelL || 0} L (fiche avion)
        </p>
      </div>

      <div className={`grid gap-5 xl:col-span-2 ${plans.length > 1 ? "sm:grid-cols-2 xl:grid-cols-1" : ""}`}>
        {plans.map((p, i) => (
          <div key={p.onboardKey} className="glass rounded-2xl p-6" data-testid={`fuel-bilan-${i}`}>
            <h3 className="mb-4 flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-wide text-cyan-400">
              <Fuel className="h-4 w-4" /> Bilan carburant{p.title ? ` — ${p.title}` : ""}
            </h3>
            <FuelBilan plan={p.plan} burn={burn} p={i ? "ret-" : ""} />
          </div>
        ))}
      </div>
    </div>
  );
}
